// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"RecentSearches_buttonContainer__ca6OF"};